import React, { Suspense, useState } from 'react';

import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { formatDateToString, formatStringToDate } from 'shared/lib';
import { lazyWithRetry } from 'shared/lib/lazyRetry';

// 달력(react-datepicker)은 모달이 열릴 때만 내려받는다 — 엔트리 번들에서 제거
const DatePickerInput = lazyWithRetry(() => import('components/input/DatePickerInput'));

interface MoveInModalProps {
  value: string;
  setValue: (value: string) => void;
  onClose: () => void;
}

const MoveInModal = ({ value, setValue, onClose }: MoveInModalProps) => {
  const { t } = useTranslation('search');
  const [selectedDate, setSelectedDate] = useState<Date | null>(formatStringToDate(value));
  const today = dayjs();

  return (
    <div className="flex w-full flex-col items-center justify-center px-0 py-1 md:px-[55px] md:py-[30px]">
      <Suspense fallback={null}>
        <DatePickerInput
          selectedDate={selectedDate}
          setSelectedDate={(date) => {
            setSelectedDate(date);
            setValue(formatDateToString(date));
            onClose();
          }}
          hideInput
          minDate={today.add(3, 'day').toDate()}
        />
      </Suspense>
      <p className="mt-2 text-center text-c2 font-medium text-gray-40">{t('moveInModal.dateSelectionNote')}</p>
    </div>
  );
};

export default MoveInModal;
